/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ComponentAction {
    OpenModal = 0,
    Navigate = 1,
    Script = 2,
}
